<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="subgroups"
      @click:row="editItem"
      :loading="loading"
      loading-text="Loading... Please wait"
      hide-default-footer
    >
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';

export default {
  name: 'PersonSubGroupList',
  computed: {
    ...mapGetters('subgroup', ['loading', 'error', 'subgroups', 'meta']),
    ...mapGetters('person', ['person'])
  },
  methods: {
    editItem(item) {
      this.$router.push('/subgroups/' + item.id);
    },
    load() {
      if (this.person.id) {
        store.dispatch('subgroup/person', {
          person_id: this.person.id
        });
      }
    },
    paginateAction(item) {
      if (item == 'next') {
        store.dispatch('subgroup/paginate', this.links.next);
      } else if (item == 'previous') {
        store.dispatch('subgroup/paginate', this.links.prev);
      }
    }
  },
  mounted() {
    this.load();
  },
  watch: {
    'person.id': function () {
      this.load();
    }
  },
  data: () => ({
    headers: [
      { text: 'Group', value: 'group_title' },
      { text: 'Title', value: 'title' }
    ]
  })
};
</script>
